import { evaluate } from "../../functions/evaluate/evaluate.qwik.mjs";
const checkIsComponentRestricted = (component, model) => {
  if (!component)
    return true;
  if (!model)
    return false;
  return component.models && component.models.length > 0 && !component.models.includes(model);
};
const getComponent = ({ block, registeredComponents, model }) => {
  var _a;
  const componentName = (_a = block.component) == null ? void 0 : _a.name;
  if (!componentName)
    return null;
  const ref = registeredComponents[componentName];
  if (!ref || checkIsComponentRestricted(ref, model)) {
    console.warn(`
      Could not find a registered component named "${componentName}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
    return void 0;
  } else
    return ref;
};
const getRepeatItemData = ({ block, context }) => {
  const { repeat, ...blockWithoutRepeat } = block;
  if (!(repeat == null ? void 0 : repeat.collection))
    return void 0;
  const itemsArray = evaluate({
    code: repeat.collection,
    localState: context.localState,
    rootState: context.rootState,
    rootSetState: context.rootSetState,
    context: context.context
  });
  if (!Array.isArray(itemsArray))
    return void 0;
  const collectionName = repeat.collection.split(".").pop();
  const itemNameToUse = repeat.itemName || (collectionName ? collectionName + "Item" : "item");
  const repeatArray = itemsArray.map((item, index) => ({
    context: {
      ...context,
      localState: {
        ...context.localState,
        $index: index,
        $item: item,
        [itemNameToUse]: item,
        [`$${itemNameToUse}Index`]: index
      }
    },
    block: blockWithoutRepeat
  }));
  return repeatArray;
};
const provideLinkComponent = (block, linkComponent) => {
  var _a;
  if ((_a = block == null ? void 0 : block.shouldReceiveBuilderProps) == null ? void 0 : _a.builderLinkComponent)
    return {
      builderLinkComponent: linkComponent
    };
  return {};
};
const provideRegisteredComponents = (block, registeredComponents, model) => {
  var _a;
  if ((_a = block == null ? void 0 : block.shouldReceiveBuilderProps) == null ? void 0 : _a.builderComponents) {
    const filteredRegisteredComponents = Object.fromEntries(Object.entries(registeredComponents).filter(([_, component]) => {
      return !checkIsComponentRestricted(component, model);
    }));
    return {
      builderComponents: filteredRegisteredComponents
    };
  }
  return {};
};
const provideBuilderBlock = (block, builderBlock) => {
  var _a;
  if ((_a = block == null ? void 0 : block.shouldReceiveBuilderProps) == null ? void 0 : _a.builderBlock)
    return {
      builderBlock
    };
  return {};
};
const provideBuilderContext = (block, context) => {
  var _a;
  if ((_a = block == null ? void 0 : block.shouldReceiveBuilderProps) == null ? void 0 : _a.builderContext)
    return {
      builderContext: context
    };
  return {};
};
const generateKey = (index) => {
  return index.toString();
};
export {
  generateKey,
  getComponent,
  getRepeatItemData,
  provideBuilderBlock,
  provideBuilderContext,
  provideLinkComponent,
  provideRegisteredComponents
};
